<template lang="pug">
  .py-2(v-if='permitExtra')
    div(v-if='grupos.length')
      a.btn.btn-link(@click="grupos = []")
        btn-content.text-error(name='delete' label='Remover Checklist Extra')
      checklist(v-model='grupos' :tipo-formulario='tipoFormulario')
    div(v-else)
      a.btn.btn-link(@click="newGrupos()")
        btn-content(name='new' label='Incluir Checklist Extra')
</template>

<script>
import { arrayToHash, hashToArray } from '@/components/checklist/converter'
import Checklist from '@/components/checklist/Index'
import { deepKey } from 'paliari-js-utils'

export default {
  components: { Checklist },

  props: {
    value: { type: Object },
    assunto: { type: Object },
  },

  data() {
    return {
      grupos: [],
    }
  },

  computed: {
    tipoFormulario() {
      return deepKey(this.assunto, 'formulario.tipo')
    },
    permitExtra() {
      return this.tipoFormulario === 'vistoria'
    },
  },

  watch: {
    grupos: {
      handler(newValue) {
        if (newValue && newValue.length > 0) {
          this.$emit('input', arrayToHash(newValue))
        } else {
          this.$emit('input', null)
        }
      },
      deep: true,
    },
    assunto(assunto) {
      if (deepKey(assunto, 'formulario.tipo') !== 'vistoria') {
        this.$set(this, 'grupos', [])
      }
    },
  },

  methods: {
    newGrupos() {
      this.grupos = hashToArray(this.newChecklist())
    },

    newChecklist() {
      const grupoId = Date.now()
      const perguntaId = Date.now() + 10

      return {
        [grupoId]: {
          id: grupoId,
          titulo: 'Verificação Extra',
          perguntas: {
            [perguntaId]: {
              id: perguntaId,
              titulo: '',
              tipo: 'text',
              obrigatorio: true,
              min_fotos: 1,
              acoes: [],
            },
          },
        },
      }
    },
  },
}
</script>
